const FETCH_FAN_CLUB_INFO = 'fanClub/FETCH_FAN_CLUB_INFO';
const FETCH_FAN_CLUB_USERS = 'fanClub/FETCH_FAN_CLUB_USERS';
const FETCH_MY_FAN_CLUB_INFO = 'fanClub/FETCH_MY_FAN_CLUB_INFO';
const PATCH_MY_FAN_CLUB_INFO = 'fanClub/PATCH_MY_FAN_CLUB_INFO';
const RESET = 'fanClub/RESET';
const FETCH_FAN_CLUB_TOP_USERS = 'fanClub/FETCH_FAN_CLUB_TOP_USERS';

export {
  FETCH_FAN_CLUB_INFO,
  FETCH_FAN_CLUB_USERS,
  FETCH_MY_FAN_CLUB_INFO,
  PATCH_MY_FAN_CLUB_INFO,
  RESET,
  FETCH_FAN_CLUB_TOP_USERS,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/fanClub/types.js